module.exports = __webpack_public_path__ + "img/zylogo.62ed5ec0.svg";